/**
 * Ajuste por regressão linear (mínimos quadrados) para linha de tendência.
 * Índices com y null/undefined são ignorados no cálculo, mas recebem valor previsto no eixo x.
 */
export function computeLinearRegressionTrend(
  yValues: Array<number | null | undefined>
): Array<number | null> {
  const points: { x: number; y: number }[] = []
  yValues.forEach((y, x) => {
    if (y != null && Number.isFinite(y)) points.push({ x, y })
  })

  if (points.length < 2) {
    return yValues.map(() => null)
  }

  let sumX = 0
  let sumY = 0
  let sumXY = 0
  let sumX2 = 0
  const n = points.length

  for (const p of points) {
    sumX += p.x
    sumY += p.y
    sumXY += p.x * p.y
    sumX2 += p.x * p.x
  }

  const denom = n * sumX2 - sumX * sumX
  if (denom === 0) {
    return yValues.map(() => null)
  }

  const slope = (n * sumXY - sumX * sumY) / denom
  const intercept = (sumY - slope * sumX) / n

  return yValues.map((_, x) => {
    const v = intercept + slope * x
    if (!Number.isFinite(v)) return null
    return Math.max(0, Math.round(v * 10) / 10)
  })
}
